import { useEffect } from 'react';

import { store } from '../../store';
import { getUsStatesThunk } from '../../store/Misc/thunks';

export const useRegisterSharedUsStates = () => {
  useEffect(() => {
    globalThis.SHARED_MODULE_DATA.usStates = store.getState().misc.salesforceUSStates;

    globalThis.SHARED_MODULE_DATA.getUsStates = async () => {
      const current = store.getState().misc.salesforceUSStates;
      if (current.length > 0) {
        globalThis.SHARED_MODULE_DATA.usStates = current;
        return current;
      }

      const result = await store.dispatch(getUsStatesThunk());
      if (getUsStatesThunk.fulfilled.match(result)) {
        globalThis.SHARED_MODULE_DATA.usStates = result.payload;
        return result.payload;
      }

      throw new Error('Failed to fetch US states');
    };

    return () => {
      delete globalThis.SHARED_MODULE_DATA.getUsStates;
    };
  }, []);
};
